import * as React from 'react';

function usePrevious(value, initialValue) {
  const storedValue = React.useRef(initialValue);
  React.useEffect(() => {
    storedValue.current = value;
  }, [value]);
  return storedValue.current;
}

export default usePrevious;